import { API_PATH, IMAGE_UPLOAD_PATH } from './config'

export function getApiPath() {
  return API_PATH
}

export function getImageUploadPath() {
  return IMAGE_UPLOAD_PATH
}
// 格式化日期
export function formatDate(dateString) {
	const date = new Date(dateString)
	const month = date.getMonth()+1
	const day = date.getDate()
	return month + '月' + day + '日'
}